import { AbstractControl, ValidationErrors } from "@angular/forms";

export function PatientIdsValidator(
  control: AbstractControl
): ValidationErrors | null {
  const nationalId = control.get('patientNationalId').value;
  const passportId = control.get('patientPassportId').value;

  if (nationalId || passportId) {
    return null;
  }

  return { patientIdIsRequired: true };
}
